import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var s = function s(_s) {
  return -1 !== _s.indexOf("Brush");
};

var e = /*#__PURE__*/function () {
  function e() {
    _classCallCheck(this, e);

    this._names = new Map();
  }

  _createClass(e, [{
    key: "begin",
    value: function begin(_e) {
      this._names.has(_e) || (this._names.set(_e, !1), s(_e) && this.record("Esri.FirstDraw"), performance.mark("Esri.".concat(_e, ".Start")));
    }
  }, {
    key: "end",
    value: function end(s) {
      this._names.has(s) && !this._names.get(s) && (this._names.set(s, !0), performance.mark("Esri.".concat(s, ".End")));
    }
  }, {
    key: "record",
    value: function record(s) {
      this._names.has(s) || (this._names.set(s, !0), performance.mark("Esri.".concat(s)));
    }
  }]);

  return e;
}();

export { e as Timeline };